const getters = {
    getExpenseList(state){
        return state.expenseList;
    },
    getExpenseTypeList(state){
        return state.expenseTypeList;
    },
    getExpense(state){
        return state.expense;
    },
    getExpenseType(state){
        return state.expenseType
    },
    getMonthlyExpenseAmount(state) {
        return state.monthlyExpenseAmount;
    }
}

export default getters;